import { create } from 'zustand';

function sortFn(a, b) {
    
    if (!a?.inicio) return 1;
    if (!b?.inicio) return -1;

    return new Date(b.inicio) - new Date(a.inicio);

}

export const useChegadasViagensStore = create((set) => ({
    
    chegadas: {},

    setChegadas: (codigo, chegadas = []) => {

        const key = String(codigo || '').trim();

        if (!key) return;

        set(state => ({
            chegadas: {
                ...state.chegadas,
                [key]: [...chegadas].sort(sortFn)
            }
        }));

    },

    upsertChegada: chegada => {
        
        const key = String(chegada?.CODIGO_INTEGRACAO || '').trim();

        if (!key) return;

        set(state => {
            
            const current = state.chegadas[key] || [];

            const next = [...current];

            const index = next.findIndex(c => Number(c.id) === Number(chegada.id));

            if (index >= 0) {
                next[index] = chegada;
            } else {
                next.push(chegada);
            }

            next.sort(sortFn);

            return {
                chegadas: {
                    ...state.chegadas,
                    [key]: next
                }
            };

        });

    },

    removeChegada: ({ id, CODIGO_INTEGRACAO }) => {

        const key = String(CODIGO_INTEGRACAO || '').trim();

        if (!key) return;

        set(state => ({

            chegadas: {
                ...state.chegadas,
                [key]: (
                    state.chegadas[key] || []
                ).filter(c =>
                    Number(c.id) !== Number(id)
                )
            }

        }));

    },

    clearChegadas: codigo => {

        const key = String(codigo || '').trim();

        if (!key) return;

        set(state => {

            const chegadas = {
                ...state.chegadas
            };

            delete chegadas[key];

            return { chegadas };

        });

    },

    clearAllChegadas: () => {

        set({
            chegadas: {}
        });

    }

}));